import * as actionTypes from '../../../constants/ActionTypes/Web/Customer/SignUp';

const initialState = {
    'success': false,
    'loading': false,
    'error': false,
    'data': {}
}

const PreEnrollment = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.PRE_ENROLLMENT_INIT:
            return {
                ...state,
                loading: true,
                'success': false,
                'error': false,
                'data': {}
            }
        case actionTypes.PRE_ENROLLMENT_SUCCESS:
            return {
                ...state,
                success: true,
                loading: false,
                data: action.enrollmentResponse,
                'error': false
            }
        case actionTypes.PRE_ENROLLMENT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.message,
                'data': {}
            }
        default:
            return {...state};
    }

}

export default PreEnrollment;